import { Button, ListableInfo, LoadingBlur, Panel } from '@ics-portal/guardian';
import { type ReactNode } from 'react';
import { type ComponentSourceRaw } from '@gql/graphql';
import { useExternalSourcesDialog } from '@components/ExternalSourcesDialog/ExternalSourcesDialog';

interface ExternalSourcesPanelProps {
    sourcesData: ComponentSourceRaw[];
    loading?: boolean;
    collapsed?: boolean;
}

export function ExternalSourcesPanel({
    sourcesData,
    loading,
    collapsed,
}: ExternalSourcesPanelProps): ReactNode {
    const { openExternalSourcesDialog } = useExternalSourcesDialog();

    return (
        <Panel header="External Sources" collapsed={collapsed}>
            <LoadingBlur loading={loading ?? false}>
                {sourcesData.length === 0 ? (
                    <p>No external sources found.</p>
                ) : (
                    <>
                        <div className="flex flex-column gap-2 pt-sm pb-lg">
                            {sourcesData.map((source) => (
                                <ListableInfo
                                    key={source.id}
                                    size="md"
                                    label={source.sourceName}
                                    value={source.cpe ?? source.id}
                                    wrap
                                />
                            ))}
                        </div>
                        <div className="flex justify-content-end">
                            <Button
                                label="See details"
                                tertiary
                                onClick={() => {
                                    openExternalSourcesDialog(sourcesData);
                                }}
                            />
                        </div>
                    </>
                )}
            </LoadingBlur>
        </Panel>
    );
}
